<template> 
	<div class="sizeChat">
				<!--{{productData.category}} -->
				<p v-if="itisfabric" class="m-0"><b-link v-b-modal.sizechatpopup @click="inLodcard">Size Chart</b-link></p> 
				
			<b-modal id="sizechatpopup" title="SIZE GUIDE Org"   ok-only     hide-footer  size="md" centered  class="p0">
				<template #modal-header style="padding:0px;">
				  <b-row class="w-100 m-0">
					<b-col cols="11" class="text-center">   <h4 class="modal-title"> SIZE GUIDE </h4></b-col>
					<b-col>  <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('sizechatpopup')">×</button></b-col>
				  </b-row>
				</template>
				<b-row>
					<b-col class="measurement-title"> <ul class="measurement-type">
							<li class="tirlemt" >All measurements are in</li>
							<li :class="{ activec : measurement == 'in' }" @click="setMeasurement('in')" >INCHES</li>
							<li :class="{ activec : measurement == 'cm' }" @click="setMeasurement('cm')">CMS</li>
						</ul></b-col>
					
					
					
				</b-row>
				<b-table class="chartTabel" responsive :items="chartData"></b-table>
				
					
			  </b-modal>
	</div>
</template>
<script>
import '../assets/sizechart.scss';
export default {
  name: 'Size chart',
  props: {
    productData: { type: Object },	
 
  },
  mounted(){
  //this.inLodcard;
  },
  computed: {
    
	itisfabric: function () {
		var catAry = this.productData.category.split(',');
		console.log('catAryFAV'+this.productData.category);
		console.log('catAry'+catAry);
		//const res = catAry.filter(v => catAry.includes(v));
		/*var res = catAry.indexOf(4);
		*/
		//var res =false;
		/*var samsung =2;
		return catAry.filter((samsung) => {
        return this.keyword.toLowerCase().split(' ').every(v => samsung.title.toLowerCase().includes(v));
      }); */
		
		/* 
		var rs= 0;
		 catAry.forEach((item) => {
		
			console.log('item:'+item); 
			if(item=='2'){
				return 0;
				//console.log('rs:RS2');
			}else if(item=='3'){
				return 0;
				//console.log('rs:RS3');
			}else if(item=='4'){
				return 0;		
				//console.log('rs:RS4');
			}else if(item=='5'){
				return 0;
				//console.log('rs:RS5');				
			}else{
				return 1;
				//console.log('rs:RS1');
			}
			
		}); 
		console.log('rs:'+rs);
		return  true;*/
		/* var searchR=2;
		 var res = catAry.filter(d => searchR.every(v => d.toLowerCase().includes(v.toLowerCase())))
		console.log('resres'+res); */
		var searchR=2;
		var tempRecipes = catAry.filter((item) => {
			  return (item==searchR);
			})
			//console.log('resres'+tempRecipes);
			return tempRecipes==2?0:1;
		
     
    },
	
	
  },
  data() {
    return{
		sizechartUrl: this.$root.WEBAPI+'sizechartapi/getSizechart',
		chartData:[],
		chartDataInch:[],
		chartDataCm:[],
		measurement:'in',
      //modaldata_qty: 1,
	  //variant:'dark',
	  //cartHeader:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
		addtofavouriteNotlogin(){
			if(this.$root.customer_info.access_key == ''){
				this.$router.push({
					name: 'Login',
					params: {
						redirect: '/category/'+this.$route.params.category
					}
				});
			}
		},
		setiamiconfor(socialame){
		this.$root.share.iamiconfor=socialame;
		},
		
	inLodcard(){
		var self = this;
		//console.log('gendr'+self.productData.gender);
		self.measurement='in';
			self.axios.post(self.sizechartUrl, {
				gender:self.productData.gender,
				title:self.productData.title,
				category:self.productData.category,
				
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                console.log(response.data);
                //self.chartData = response.data.result.chartData;
               var chartresult = response.data.result.chartData;
						self.chartDataInch=[];
						self.chartDataCm=[];
						self.chartData=[];
					chartresult.forEach((item,index) => {
						/* var arrayCsv={'Seller Name':item.fullname,'Phone':item.mobile};	 */
						console.log('index:'+index+'item'+item.size);
						/*
						var arrayCsv={'size':item.size,'shoulder':item.shoulder,'bust':item.bust,'waist':item.waist,'hip':item.hip,'length':item.length,'neck':item.neck,'chest':item.chest};
						*/
						
						var arrayCsv={'size':item.size};
						var arrayCsvCm={'size':item.size};
						if(item.shoulder>0){
							arrayCsv.shoulder = item.shoulder;
							arrayCsvCm.shoulder = self.$root.tofixed(item.shoulder * 2.57, 0);
						}
						if(item.bust>0){
							arrayCsv.bust = item.bust;
							arrayCsvCm.bust = self.$root.tofixed(item.bust * 2.57, 0);
						}if(item.waist>0){
							arrayCsv.waist = item.waist;
							arrayCsvCm.waist = self.$root.tofixed(item.waist * 2.57, 0);
						}if(item.hip>0){
							arrayCsv.hip = item.hip;
							arrayCsvCm.hip = self.$root.tofixed(item.hip * 2.57, 0);
						}if(item.length>0){
							arrayCsv.length = item.length;
							arrayCsvCm.length = self.$root.tofixed(item.length * 2.57, 0);
						}if(item.neck>0){
							arrayCsv.neck = item.neck;
							arrayCsvCm.neck = self.$root.tofixed(item.neck * 2.57, 0);
						}if(item.chest>0){
							arrayCsv.chest = item.chest;
							arrayCsvCm.chest = self.$root.tofixed(item.chest * 2.57, 0);
						}if(item.euro>0){
							arrayCsv.euro = item.euro;
							arrayCsvCm.euro =item.euro;
						}
						
					
						self.chartDataInch.push(arrayCsv);
						self.chartDataCm.push(arrayCsvCm);
						self.chartData.push(arrayCsv);
					});
				
				
				
				
                    /*  self.videoCategory = response.data.result.videoCategory;
					self.topCategory = response.data.result.topCategory;
                  self.brandList = response.data.result.brandList; 
				  */
                  
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
	},
	setMeasurement(meas){
		var self = this;
		self.chartData=[];
		self.measurement=meas;
		if(meas=='in'){
			self.chartData=self.chartDataInch;
		}else{
			self.chartData=self.chartDataCm;
		}
		
	
	}	
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style    lang="scss">
 
</style>